import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { EventDto } from "../../../models/event/dto/event.dto";
import { UpdateEventInputDto } from "../../../models/event/dto/update-event.dto";
import { GET_EVENT_QUERY_KEY } from "./useGetEvent";
import { GET_EVENTS_QUERY_KEY } from "./useListEvents";

export const useUpdateEvent = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['updateEvent'],
        mutationFn: ({ id, dto }: { id: number; dto: UpdateEventInputDto }) =>
            client.fetchApi<EventDto, UpdateEventInputDto>({
                endpoint: `events/${id}`,
                method: 'PUT',
                body: dto
            }),
        onSuccess: (data) => {
            // Update the individual event cache
            queryClient.setQueryData(GET_EVENT_QUERY_KEY(data.id), () => data);

            // Update the events list cache for both past and future events
            const locationId = data.organizationLocation.id;
            ['past', 'future'].forEach(direction => {
                queryClient.setQueryData(GET_EVENTS_QUERY_KEY(locationId, direction as 'past' | 'future'), (prevList: EventDto[] | undefined) => {
                    if (!prevList) return prevList;

                    const updatedList = prevList.map(event =>
                        event.id === data.id ? data : event
                    );

                    // Sort by start time
                    return updatedList.sort((a, b) => {
                        return new Date(a.startTime).getTime() - new Date(b.startTime).getTime();
                    });
                });
            });
        }
    });
};
